import styled from '@emotion/styled';
import { useMediaQuery } from '@mui/material';

const StyledName = styled('h4')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 500,
}));

type CommentUserNameProps = {
  name: string;
};

const CommentUserName = ({ name }: CommentUserNameProps) => {
  const shouldOnlyShowFirstName = useMediaQuery('(max-width: 450px)');

  const firstName = name.split(' ')[0];

  return <StyledName>{shouldOnlyShowFirstName ? firstName : name}</StyledName>;
};

export default CommentUserName;
